export class RecommendationModel {
  constructor(public properties: RecommendationModelProperties) {}
}

export type RecommendationModelProperties = {
  widgetName: string;
  widgetId: string;
  recommendationType:
    | 'bestsellers'
    | 'newest-arrivals'
    | 'frequently-bought-together'
    | 'trending-products'
    | 'hand-picked-products'
    | 'recently-viewed'
    | 'most-viewed'
    | 'related-items';
  widgetDesignSettings?: WidgetDesignSettings;
  page: SupportedPage;
  products: Product[];
};

export type SupportedPage = 'home-page' | 'cart-page' | 'collection-page' | 'product-page';

type WidgetDesignSettings = {
  layoutDisplay?: 'carousel' | 'grid' | 'bundle';
  numberOfProductPerRow?: number;
  numberOfRecommendProduct?: number;
  bundleStyle?: 'style1' | 'style2';
  templateType?: 'default' | 'customization';
  themePreview?: string;
  titleAlignment?: 'center' | 'left';
  titleFont?: string;
  titleFontSize?: number;
  titleFontStyle?: string;
  titleFontWeight?: string | number;
  titleTextColor?: string;
  titleTextTransform?: 'capitalize';
};

type Product = {
  type?: string;
  available: boolean;
  barcodes: string[];
  best_selling_rank: number;
  body_html: string;
  collections: Array<{
    handle: string;
    id: number;
    sort_value: string;
    template_suffix: string;
    title: string;
  }>;
  compare_at_price_max: number | null;
  compare_at_price_min: number | null;
  created_at: string;
  extra_sort1: string | number | null;
  extra_sort2: string | number | null;
  extra_sort3: string | number | null;
  handle: string;
  html: {
    theme_id: number;
    value: string;
  };
  id: number;
  images: {
    [key: string]: string;
  };
  original_images?: Array<{
    alt?: string;
    height?: number;
    id?: number;
    position?: number;
    src?: string;
    width?: number;
  }>;
  images_info?: Array<{
    alt: string;
    height: number;
    id: number;
    position: number;
    src: string;
    width: number;
  }>;
  locations: Array<unknown>;
  metafields: Array<ProductMetaField>;
  options_with_values: Array<OptionsWithValues>;
  percent_sale_min: number | null;
  position: number | null;
  price_max: number;
  price_min: number;
  product_type: string;
  published_at: string;
  published_scope: string;
  review_count: number;
  review_ratings: number;
  skus: string[];
  tags?: string[];
  template_suffix: string;
  title: string;
  updated_at: string;
  variant_id?: number;
  variants: Array<ProductItemVariant>;
  vendor: string;
  weight_max: number | null;
  weight_min: number | null;
  original_tags?: string[];
};

type ProductMetaField = {
  type?: string;
  namespace?: string;
  key?: string;
  value?: string;
};

type ProductItemVariant = {
  available: boolean;
  barcode: string;
  compare_at_price: string | null;
  fullfillment_service: string;
  id: string;
  image: string | null;
  inventory_management: string;
  inventory_policy: string;
  inventory_quantity: number;
  merged_options: Array<string>;
  original_merged_options?: Array<string>;
  price: string;
  sku: string;
  title: string;
};

type OptionsWithValues = {
  values: Array<{ image: number | null; title: string; origin_title?: string }>;
  name: string;
  original_name?: string;
  label: string;
};
